import { Header } from "../Header/Header"
import { HerosectionsAll } from "../../HeroSectionAll/HerosectionsAll"
import { Footer } from "../../Footer/Footer"
import { Link, useSearchParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"
import { useAuthState } from "../../../helper/Context/context"
import { GET_M_WebinarMaster_SelectAPI } from "../../../helper/Redux/Slices/Admin/WebinarMasterSlice/WebinarMasterSlice"
import { LogoLoader } from "../../../helper/Loaders/LogoLoader"
import { getSelectedMonthDateRange } from "../../../helper/DateRange/DateRange"
import { PastWebinarsCarousel } from "./PastWebinarsCarousel"
import { UpcomingWebinarSection } from "./UpcomingWebinarSection"


function getWebinarMoment(item) {
    if (!item) return null
    if (item.webinarDate) {
        const m = moment(item.webinarDate)
        if (m.isValid()) return m
    }
    if (item.toDate) {
        const m = moment(item.toDate, ["DD MMM YYYY", "YYYY-MM-DD", "DD/MM/YYYY"])
        if (m.isValid()) return m
    }
    if (item.fromDate) {
        const m = moment(item.fromDate, ["DD MMM YYYY", "YYYY-MM-DD", "DD/MM/YYYY"])
        if (m.isValid()) return m
    }
    return null
}

export const Webinars = () => {
    const [searchparams] = useSearchParams()

    const dispatch = useDispatch()
    const userDetails = useAuthState()
    const { year, Month, Language } = userDetails
    const { UserID, token } = userDetails.user

    const initialFromDate = searchparams.get("FromDate") || ""
    const initialToDate = searchparams.get("ToDate") || ""

    const [isAuthenticated, setIsAuthenticated] = useState(
        () => Boolean(sessionStorage.getItem("A454A"))
    )

    useEffect(() => {
        handleGetData()
    }, [year?.Label, Month?.ID, Language?.Label])

    const handleGetData = () => {

        const data = {
            WebinarID: 0,
            SearchTerm: "",
            FromDate: "",
            ToDate: "",
            Flag: "Details",
            M_UserID: UserID ? UserID : 0,
            Language: Language?.Label || "",
            FromTop: 1,
            ToTop: 100,
            token: token,
        }

        dispatch(GET_M_WebinarMaster_SelectAPI({ data }))
    }

    const { isLoading, TableData } = useSelector((state) => state.GET_M_WebinarMaster_SelectData)

    const webinarsList = Array.isArray(TableData)
        ? TableData
        : (TableData?.data?.table && Array.isArray(TableData.data.table) ? TableData.data.table : [])
    const today = moment().startOf("day")

    const upcomingWebinars = webinarsList
        .filter((item) => {
            const m = getWebinarMoment(item)
            return m ? m.startOf("day").isSameOrAfter(today) : false
        })
        .sort((a, b) => {
            const mA = getWebinarMoment(a)
            const mB = getWebinarMoment(b)
            return (mA ? mA.valueOf() : 0) - (mB ? mB.valueOf() : 0)
        })

    const pastWebinars = webinarsList
        .filter((item) => {
            const m = getWebinarMoment(item)
            return m ? m.startOf("day").isBefore(today) : true
        })
        .sort((a, b) => {
            const mA = getWebinarMoment(a)
            const mB = getWebinarMoment(b)
            return (mB ? mB.valueOf() : 0) - (mA ? mA.valueOf() : 0)
        })

    const topFlyerPhoto = upcomingWebinars.length > 0 && upcomingWebinars[0]?.webinarPhotoPath
        ? upcomingWebinars[0].webinarPhotoPath
        : "/Static/Assets/Img/Webinars/Free_Webinar.jpeg"

    return (
        <>
            {isLoading && <LogoLoader />}
            <div
                className="container-fluid"
                style={{ background: "#fff", minHeight: "100vh", display: "flex", flexDirection: "column" }}
            >
                <div className="row flex-grow-1">
                    <div className="col-12 d-flex flex-column">
                        <Header actives="Webinars" subactive="Events" />
                        <HerosectionsAll ScreenName="Webinars" ScreenSearch="Webinars" />

                        <main
                            className="container-fluid px-3 px-md-4 px-xl-5 py-4 py-lg-5"
                            style={{ height: "auto", flex: "1 0 auto" }}
                        >
                            {isLoading && <LogoLoader />}
                            {upcomingWebinars.length > 0 && (
                                <>
                                    <header className="text-center mb-4 mb-lg-5">
                                        <p
                                            className="fw-bold text-uppercase mb-2"
                                            style={{ color: "#cd9e53", letterSpacing: "0.12em" }}
                                        >
                                            MILSO Academy
                                        </p>
                                        <h1 className="fw-bold mb-0" style={{ color: "#16374e" }}>
                                            Webinars
                                        </h1>
                                    </header>

                                    {/* Flyer Banner */}

                                    <div className="row col-12 mx-auto mt-3 mb-4">
                                        <div className="row justify-content-center">
                                            <div
                                                className="text-center py-3 rounded"
                                                // style={{
                                                //     backgroundColor: "#16374e",
                                                //     width: "90%",
                                                // }}
                                                style={{
                                                    backgroundColor: "#16374e",
                                                    width: "100%",
                                                    height: "auto",
                                                }}
                                            >
                                                <h5 className="fw-bold text-white pb-2 ">Upcoming Webinar</h5>
                                                <img
                                                    src={topFlyerPhoto}
                                                    alt={upcomingWebinars[0]?.title || "Upcoming Webinar"}
                                                    onError={(e) => {
                                                        e.currentTarget.onerror = null
                                                        e.currentTarget.src = "/Static/Assets/Img/Webinars/Free_Webinar.jpeg"
                                                    }}
                                                    className="img-fluid rounded"
                                                    style={{
                                                        objectFit: "contain",
                                                        width: "100%",
                                                        height: "auto",
                                                        maxHeight: "75vh",
                                                        // boxShadow: "10px 10px #cd9e53",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Upcoming Webinars Section */}
                            {upcomingWebinars.length > 0 ? (
                                upcomingWebinars.map((webinar, index) => (
                                    <UpcomingWebinarSection key={webinar.webinarID || index} webinar={webinar} />
                                ))
                            ) : (
                                <section
                                    aria-labelledby="upcoming-webinar-title"
                                    className="row g-0 align-items-stretch overflow-hidden rounded shadow-sm mb-4 mb-lg-5"
                                    style={{ backgroundColor: "#f5f7f8" }}
                                >
                                    <div className="col-12 p-4 p-lg-5 text-center">
                                        <span
                                            className="badge rounded-pill px-3 py-2 mb-3"
                                            style={{ backgroundColor: "#cd9e53", color: "#16374e" }}
                                        >
                                            Upcoming webinar
                                        </span>
                                        <h3 className="fw-bold mb-2" style={{ color: "#16374e" }}>
                                            No Upcoming Webinars Currently Scheduled
                                        </h3>
                                        <p className="text-muted mb-0">
                                            Please check back later or explore our recorded webinar sessions below.
                                        </p>
                                    </div>
                                </section>
                            )}

                            {/* CTA: View Webinar Videos */}
                            <section className="mb-4 mb-lg-5">
                                <div
                                    className="text-center rounded shadow-sm px-4 py-5 px-lg-5"
                                    style={{
                                        background: "linear-gradient(135deg, #16374e 0%, #214f6f 100%)",
                                        border: "1px solid rgba(205, 158, 83, 0.35)",
                                    }}
                                >
                                    <p
                                        className="fw-bold text-uppercase mb-2"
                                        style={{ color: "#cd9e53", letterSpacing: "0.12em" }}
                                    >
                                        MILSO Academy
                                    </p>
                                    <h3 className="fw-bold mb-3" style={{ color: "#fff" }}>
                                        Would you like to View Webinar Videos?
                                    </h3>
                                    <p className="mb-4 mx-auto" style={{ maxWidth: "700px", color: "#edf2f5" }}>
                                        Explore our recorded sessions and catch up on expert insights on marine insurance,
                                        risk management, and industry trends.
                                    </p>

                                    <Link
                                        className="btn fw-semibold px-4 py-2"
                                        to={!isAuthenticated ? "/AllWebinarVideos" : "/WebinarVideos"}
                                        style={{ backgroundColor: "#cd9e53", color: "#16374e", fontWeight: "bold" }}
                                    >
                                        View Webinar Videos
                                    </Link>
                                </div>
                            </section>

                            {/* Past Webinars Section (3 cards in one row & horizontal carousel) */}
                            <PastWebinarsCarousel webinars={pastWebinars} />

                        </main>

                        <div className="mt-auto">
                            <Footer />
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

